type Option = {
  label: string;
  value: string;
};

type Props = {
  options: Option[];
  value: string;
  onChange: (value: string) => void;
  ariaLabel?: string;
};

export default function SegmentedControl({ options, value, onChange, ariaLabel }: Props) {
  return (
    <div
      role="tablist"
      aria-label={ariaLabel}
      className="inline-flex items-center gap-1 p-1 rounded-full bg-background-100 border border-background-200 max-w-full overflow-x-auto no-scrollbar"
    >
      {options.map((option) => (
        <button
          key={option.value}
          type="button"
          role="tab"
          aria-selected={value === option.value}
          onClick={() => onChange(option.value)}
          className={`h-8 px-3.5 rounded-full text-xs whitespace-nowrap transition-colors cursor-pointer ${
            value === option.value
              ? 'bg-primary-500 text-background-50'
              : 'text-foreground-600 hover:text-primary-700'
          }`}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}